import PropTypes from 'prop-types';
import { FormControl, MenuItem, Grid, FormLabel, TextField } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { dataAll } from '../../service/data.service';

const franchiseesSample = [
  { code: '', name: '', state: '' },
];

const FranchiseePicker = ({ label, value, onChange }) => {

  const [franchisees, setFranchisees] = useState(franchiseesSample)
  const [filteredFranchisees, setFilteredFranchisees] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchAllItems = async () => {
    try {
      const response = await dataAll('/club/franchisees')
      setFranchisees(response || franchiseesSample)

    } catch (error) {
      toast.error('Erro ao buscar relatório comparativo receita x recebido. Favor tentar novamente dentro de alguns instantes. Sinalize o suporte caso persista. Erro técnico:', error)

    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAllItems()
  }, [])

  useEffect(() => {
    const selected = value.state
    if (selected) {
      setFilteredFranchisees(franchisees.filter(f => f.state === selected));
    } else {
      setFilteredFranchisees(franchisees);
    }
  }, [franchisees, value])

  const handleChange = (e) => {
    onChange({ ...value, franchisee: e.target.value });
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
      <FormLabel component="legend" style={{ minWidth: 40 }}>
        {label}
      </FormLabel>

      <FormControl variant="outlined" size="small">
        <TextField
          select
          label="Franquia"
          value={value?.franchisee ?? ''}
          onChange={handleChange}
          variant="outlined"
          size="small"
          InputLabelProps={{ shrink: true }}
          fullWidth
        >
          {!loading && filteredFranchisees.map(({ code, name }) => (
            <MenuItem key={code} value={code}>{name}</MenuItem>
          ))}
        </TextField>
      </FormControl>
    </div>
  );
};

FranchiseePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.shape({
    year: PropTypes.number.isRequired,
    month: PropTypes.number.isRequired,
    state: PropTypes.string.isRequired,
    franchisee: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FranchiseePicker;
